import { Box, Typography } from '@mui/material'
import { homeHero } from '../../assets/index'
import { heroDisplayFontSize } from '../../theme/scale'
import PrimaryButton from '../common/PrimaryButton'
import SecondaryButton from '../common/SecondaryButton'
import { HOME_MOBILE_MQ, homeMobileButtonSx, homeMobilePaddingX } from './homeMobileLayout'

export default function HeroSection() {
  return (
    <Box
      sx={{
        position: 'relative',
        minHeight: { xs: 800, md: 900, lg: 1000 },
        display: 'flex',
        alignItems: { xs: 'flex-start', sm: 'center' },
        overflow: 'hidden',
        [HOME_MOBILE_MQ]: { minHeight: 800 },
      }}
    >
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          '&::after': {
            content: '""',
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(65deg, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 96%)',
          },
        }}
      >
        <Box
          component="img"
          src={homeHero}
          alt="Disha Foundation hero"
          sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      </Box>

      <Box
        sx={{
          position: 'relative',
          zIndex: 1,
          width: '100%',
          maxWidth: 1520,
          mx: 'auto',
          px: homeMobilePaddingX,
          pt: { xs: '80px', sm: 0 },
          pb: { xs: 6, sm: 0 },
          boxSizing: 'border-box',
          [HOME_MOBILE_MQ]: { pt: '80px' },
        }}
      >
        <Box
          sx={{
            maxWidth: { xs: '100%', sm: 480, md: 560, lg: 660 },
            mx: { sm: 'auto' },
            textAlign: { xs: 'left', sm: 'center' },
          }}
        >
          <Typography
            component="h1"
            sx={{
              fontSize: { xs: 40, sm: 48, md: 56, lg: heroDisplayFontSize.lg },
              color: '#fffefa',
              lineHeight: 'normal',
              mb: { xs: '16px', sm: 3 },
              maxWidth: { xs: 362, sm: '100%', md: '100%' },
              mx: { sm: 'auto' },
              [HOME_MOBILE_MQ]: { fontSize: 40, mb: '16px' },
            }}
          >
            Empowering Youth Through Leadership & Nation Building
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 14, sm: 18, md: 20 },
              color: 'rgba(255,254,250,0.8)',
              lineHeight: 'normal',
              mb: { xs: '24px', sm: 4 },
              maxWidth: { xs: 362, sm: '100%', md: '100%' },
              mx: { sm: 'auto' },
              [HOME_MOBILE_MQ]: { fontSize: 14, mb: '24px' },
            }}
          >
            Disha Foundation is dedicated to developing young leaders who will shape India's
            future through leadership development programs, cultural initiatives, women empowerment,
            and good governance awareness.
          </Typography>
          <Box
            sx={{
              display: 'flex',
              gap: { xs: '14px', sm: 2.5 },
              flexWrap: 'wrap',
              justifyContent: { xs: 'flex-start', sm: 'center' },
              [HOME_MOBILE_MQ]: { gap: '14px' },
            }}
          >
            <PrimaryButton
              to="/plc-4"
              showArrow={false}
              sx={{
                [HOME_MOBILE_MQ]: homeMobileButtonSx,
              }}
            >
              Explore PLC 4.0
            </PrimaryButton>
            <SecondaryButton
              to="/events"
              sx={{
                [HOME_MOBILE_MQ]: homeMobileButtonSx,
              }}
            >
              Disha Sessions
            </SecondaryButton>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
